import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import {
  reportCountAllOrg,
  reportFilterCount,
} from '/redux/selector/myTeams.selector';
import {
  allReportData,
  reportData,
  reportIsLoadingStateValue,
  reportMeta,
} from '/redux/selector/report.selector';
import {watchlistCount} from '/redux/selector/watchList.selector';

import ReportDataProvider from './ReportDataProvider';

export default connect(
  createStructuredSelector({
    reportIsLoading: reportIsLoadingStateValue,
    reportData,
    reportMeta,
    allReportData,
    watchlistCount,
    viewTeamsReportFilterCount: reportFilterCount,
    viewTeamsReportCountAllOrg: reportCountAllOrg,
  }),
)(ReportDataProvider);
